export const TAGS = {
  KID: 'KID', // 兒童課程,
  ADULT: 'ADULT', // 成人課程,
  TOPIC: 'TOPIC', // 技術專題,
  NFT: 'NFT', // NFT專屬課程,
  SHOW_IN_LIST: 'SHOW_IN_LIST', // 顯示在列表,
  OFFICIAL: 'OFFICIAL', // 官方課程 (原 type2: 一般課程),
  TRIAL: 'TRIAL', // 體驗課程,
  KINI: 'KINI', // 棋院內部
  ACADEMY: 'ACADEMY', // 棋院內部
  KGP: 'KGP', // 幼兒園課程,
  TGC: 'TGC', // 圍棋學院
  CLASS_COURSE: 'CLASS_COURSE', // 班級專用課程
};

export const CONTENT_TYPES = {
  VIDEO: 'VIDEO',
  GAME: 'GAME',
  TSUME: 'TSUME',
};

export default {
  TAGS,
  CONTENT_TYPES,
};
